import { testimonials } from "../data/content";

function TestimonialsSection() {
  return (
    <section className="section">
      <div className="section-title">
        <p>Testimonials</p>
        <h2>Local Families Trust GURU KRIPA</h2>
      </div>
      <div className="grid">
        {testimonials.map((testimonial) => (
          <article key={testimonial.name} className="card testimonial">
            <p>“{testimonial.quote}”</p>
            <h4>{testimonial.name}</h4>
          </article>
        ))}
      </div>
    </section>
  );
}

export default TestimonialsSection;
